import EMITTER from "@core/emitter";
import { STATE } from "@core/state";
import { LOGO_MINIMUM, LOGO_MINIMUM_CLASSNAME, SCROLL_MINIMUM, SCROLL_MINIMUM_CLASSNAME } from "@scroll/constants";
import { body } from "@utils/dom";

class ScrollMinimum {
  constructor(scroll) {
    this.scroll = scroll;

    this._hasScrolledAboveThreshold = false;
    this._hasLogoAboveThreshold = false;
    this._started = false;

    this._onScroll = this._onScroll.bind(this);
  }

  start() {
    if( this._started ) return;
    this._started = true;

    EMITTER.on("SiteScroll.scroll", this._onScroll);
  }
  stop() {
    if( !this._started ) return;
    this._started = false;

    EMITTER.off("SiteScroll.scroll", this._onScroll);
  }
  reset() {
    this._hasScrolledAboveThreshold = false;
    this._hasLogoAboveThreshold = false;
  }

  _onScroll({ y }) {
    const threshold = y > SCROLL_MINIMUM;
    const logo = y > LOGO_MINIMUM;

    // if scroll is greater than threshold AND was previously lower than threshold
    if (threshold === true && this._hasScrolledAboveThreshold === false) {
      this._hasScrolledAboveThreshold = true;
      STATE.dispatch("SCROLL_MIN", true);

      body.classList.add(SCROLL_MINIMUM_CLASSNAME);
      EMITTER.emit("SiteScroll.scroll-min", true);
    }
    // if scroll is lower than threshold AND was previously greater than threshold
    else if (threshold === false && this._hasScrolledAboveThreshold === true) {
      this._hasScrolledAboveThreshold = false;
      STATE.dispatch("SCROLL_MIN", false);

      body.classList.remove(SCROLL_MINIMUM_CLASSNAME);
      EMITTER.emit("SiteScroll.scroll-min", false);
    }

    // if logo is greater than threshold AND was previously lower than threshold
    if (logo === true && this._hasLogoAboveThreshold === false) {
      this._hasLogoAboveThreshold = true;
      STATE.dispatch("LOGO_MIN", true);

      body.classList.add(LOGO_MINIMUM_CLASSNAME);
      EMITTER.emit("SiteScroll.logo-min", true);
    }
    // if logo is lower than threshold AND was previously greater than threshold
    else if (logo === false && this._hasLogoAboveThreshold === true) {
      this._hasLogoAboveThreshold = false;
      STATE.dispatch("LOGO_MIN", false);

      body.classList.remove(LOGO_MINIMUM_CLASSNAME);
      EMITTER.emit("SiteScroll.logo-min", false);
    }
  }
}

export default ScrollMinimum;
